var render = function render(){var _vm=this,_c=_vm._self._c;return _c('subsystem-iframe-shell',{attrs:{"external-path":"/desk/areaData","frame-title":"面积切分"}})
}
var staticRenderFns = []

export { render, staticRenderFns }